import { defineStore } from "pinia";
import { computed, ref } from "vue";
import { apiLibrary } from "@/api";
import type { AxiosError } from "axios";
import * as Sentry from "@sentry/vue";
import type { PredefinedDocument } from "@/api/modules/autoQ/documents/types.ts";

export const usePredefinedDocumentStore = defineStore("predefinedDocumentsStore", () => {
    const predefinedDocuments = ref<PredefinedDocument[]>([]);
    const getPredefinedDocuments = async () => {
        try {
            const { data } = await apiLibrary.autoQ.documents.getPredefinedDocuments();

            predefinedDocuments.value = data;
        } catch (err) {
            const error = err as AxiosError;

            console.error(error.message);
            Sentry.captureException(error);
        }
    };

    const hasPredefinedDocuments = computed(() => !!predefinedDocuments.value.length);

    return {
        predefinedDocuments,
        getPredefinedDocuments,
        hasPredefinedDocuments
    };
});